import React, { useState } from 'react';
import 'react-tabs/style/react-tabs.css';
import { IconButton } from '@mui/material';
import CachedIcon from '@mui/icons-material/Cached';
import DoneIcon from '@mui/icons-material/Done';

const Result = ({ swapInfo, success, close }) => {
  const [isCopied, setIsCopied] = useState(false);
  const [copyId, setCopyId] = useState('');
  const handleCopy = (str, id) => {
    navigator.clipboard.writeText(str);
    setIsCopied(true);
    setCopyId(id)
    setTimeout(() => {
      setIsCopied(false);
      setCopyId('');
    }, 3000);
  };

  return (
    <>
      <div className="main details center">
        <div className="heading">
          <h4>Success</h4>
          <div className="icon">
            <svg
              width="10"
              height="8"
              viewBox="0 0 10 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 3.99967L3.66667 6.66634L9 1.33301"
                stroke="white"
                stroke-width="2"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
        <p>
          Transaction sent successfully, Swap {swapInfo.amounts.sell}{' '}
          <span>{swapInfo.token.symbol}</span> for {swapInfo.amounts.get} OSCAR!
        </p>
 
        <ul className="status"> 
          <li className="top">
            <p>
              <strong>Please note</strong>: Your tokens will be available for claiming on the <strong>Base network</strong> within the next <strong>24 hours</strong>.
              <br />
              During this period, we are reviewing and securely bridging your transaction to ensure everything is set for you to claim your tokens seamlessly.
            </p>
          </li> 
        </ul>
        
        <ul className="status">
    
          <li className="top">
            <p className="desc">Status</p>
            <p className="text">Completed</p>
          </li>
          <li className="s-body">
            <p className="desc">Transaction Hash</p>
            <p className="text">
              {swapInfo.hash
                ? `${swapInfo.hash.slice(0, 6)}...${swapInfo.hash.slice(
                    swapInfo.hash.length - 6,
                    swapInfo.hash.length
                  )}`
                : ''}
              {isCopied === false &&  copyId !== 1 && (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() => {
                    handleCopy(swapInfo.hash, 1);
                  }}
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9 20C11.7614 20 14 17.7614 14 15C14 12.2386 11.7614 10 9 10C6.23858 10 4 12.2386 4 15C4 17.7614 6.23858 20 9 20ZM9 22C12.866 22 16 18.866 16 15C16 11.134 12.866 8 9 8C5.13401 8 2 11.134 2 15C2 18.866 5.13401 22 9 22Z"
                    fill="#777E90"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M15.0001 4C13.5193 4 12.1899 4.6424 11.273 5.66691C10.9047 6.07844 10.2725 6.11346 9.86093 5.74513C9.4494 5.37681 9.41438 4.74461 9.78271 4.33309C11.063 2.9026 12.9268 2 15.0001 2C18.866 2 22.0001 5.13401 22.0001 9C22.0001 11.0733 21.0975 12.937 19.667 14.2173C19.2554 14.5857 18.6232 14.5507 18.2549 14.1391C17.8866 13.7276 17.9216 13.0954 18.3331 12.7271C19.3577 11.8101 20.0001 10.4807 20.0001 9C20.0001 6.23858 17.7615 4 15.0001 4Z"
                    fill="#777E90"
                  />
                </svg>
              )}
              {isCopied === true && copyId === 1 && <DoneIcon />}
            </p>
          </li>
          
        </ul>
  
      </div>
      <div className="main payment">
        <h6 className="title">Transfer Details</h6>

        <ul className="status">
          <li>
            <p className="desc">Vesting Period</p>
            <p className="text">{swapInfo.token.vesting_period}</p>
          </li>
          <li>
            <p className="desc">Exchange Rate</p>
            <p className="text">{swapInfo.token.exchange_rate}</p>
          </li>
          <li>
            <p className="desc">Token</p>
            <p className="text">{swapInfo.token.name}</p>
          </li>
          <li>
            <p className="desc">Address</p>
            <p className="text">
            {swapInfo.token.address ? swapInfo.token.address.slice(0, 5) : ''}
              .....
              {swapInfo.token.address
                ? swapInfo.token.address.slice(
                    swapInfo.token.address.length - 6,
                    swapInfo.token.address.length
                  )
                : ''}
              {isCopied === false &&  copyId !== 2 && (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() => {
                    handleCopy(swapInfo.token.address, 2);
                  }}
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9 20C11.7614 20 14 17.7614 14 15C14 12.2386 11.7614 10 9 10C6.23858 10 4 12.2386 4 15C4 17.7614 6.23858 20 9 20ZM9 22C12.866 22 16 18.866 16 15C16 11.134 12.866 8 9 8C5.13401 8 2 11.134 2 15C2 18.866 5.13401 22 9 22Z"
                    fill="#777E90"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M15.0001 4C13.5193 4 12.1899 4.6424 11.273 5.66691C10.9047 6.07844 10.2725 6.11346 9.86093 5.74513C9.4494 5.37681 9.41438 4.74461 9.78271 4.33309C11.063 2.9026 12.9268 2 15.0001 2C18.866 2 22.0001 5.13401 22.0001 9C22.0001 11.0733 21.0975 12.937 19.667 14.2173C19.2554 14.5857 18.6232 14.5507 18.2549 14.1391C17.8866 13.7276 17.9216 13.0954 18.3331 12.7271C19.3577 11.8101 20.0001 10.4807 20.0001 9C20.0001 6.23858 17.7615 4 15.0001 4Z"
                    fill="#777E90"
                  />
                </svg>
              )}
              {isCopied === true && copyId === 2 && <DoneIcon />}
            </p>
          </li>
        </ul>
        <div className="group-button">
          <button
            className="cancel btn-action-3"
            style={{ marginLeft: '50%' }}
            onClick={close}
          >
            Close
          </button>
        </div>
      </div>
    </>
  );
};

export default Result;
